import { motion } from "framer-motion";
import { cn } from "@/utils/cn";

const recentItems = [
  {
    id: 1,
    name: "Maria Santos",
    message: "Olá, preciso de ajuda com meu pedido...",
    time: "2 min",
    status: "active",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face",
  },
  {
    id: 2,
    name: "João Pedro",
    message: "Qual o prazo de entrega?",
    time: "5 min",
    status: "waiting",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
  },
  {
    id: 3,
    name: "Ana Julia",
    message: "Obrigada pelo atendimento!",
    time: "12 min",
    status: "resolved",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
  },
  {
    id: 4,
    name: "Carlos Mendes",
    message: "Posso fazer a troca do produto?",
    time: "18 min",
    status: "active",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face",
  },
  {
    id: 5,
    name: "Fernanda Lima",
    message: "Enviem o boleto por favor",
    time: "25 min",
    status: "waiting",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face",
  },
];

const statusStyles = {
  active: { bg: "bg-green-50", text: "text-[#22C55E]", label: "Ativo" },
  waiting: { bg: "bg-yellow-50", text: "text-[#FACC15]", label: "Aguardando" },
  resolved: { bg: "bg-blue-50", text: "text-[#2563EB]", label: "Resolvido" },
};

export function RecentAttendance() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      className="rounded-[14px] bg-white p-6 shadow-sm border border-[#E2E8F0]"
    >
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-lg font-semibold text-[#0F172A]">
          Atendimentos Recentes
        </h3>
        <button className="text-sm font-medium text-[#2563EB] hover:underline">
          Ver todos
        </button>
      </div>

      <div className="space-y-3">
        {recentItems.map((item, index) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 + index * 0.05 }}
            className="flex items-center gap-3 rounded-xl p-3 transition-colors hover:bg-[#F8FAFC] cursor-pointer"
          >
            <img
              src={item.avatar}
              alt={item.name}
              className="h-10 w-10 rounded-full object-cover"
            />
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold text-[#0F172A] truncate">
                  {item.name}
                </p>
                <span className="text-xs text-[#64748B] ml-2">{item.time}</span>
              </div>
              <p className="text-xs text-[#64748B] truncate">{item.message}</p>
            </div>
            <span
              className={cn(
                "rounded-full px-2 py-0.5 text-xs font-medium",
                statusStyles[item.status as keyof typeof statusStyles].bg,
                statusStyles[item.status as keyof typeof statusStyles].text
              )}
            >
              {statusStyles[item.status as keyof typeof statusStyles].label}
            </span>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}